import * as React from 'react';
import { convertIcon } from '../components/Icon';
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2,
    width: 2,
    height: 20,
    rx: 1,
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 2,
    width: 2,
    height: 20,
    rx: 1,
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12h12",
    stroke: "#4CC3FA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 9 3 3-3 3",
    stroke: "#4CC3FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 9-3 3 3 3",
    stroke: "#4CC3FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const IconComponent = convertIcon(SvgComponent, 'space');
export default IconComponent;